import { GoogleSheetsServiceComponent } from './GoogleSheetsServiceComponent';

/**
 * @deprecated It is migrating to Unified account and uses appropriate config
 * This config will be deleted soon
 */
export const GoogleSheetsReconnectionConfig = {
  serviceComponent: GoogleSheetsServiceComponent
};